module.exports = {"320321001":"中阳里街道","320321002":"凤城街道","320321003":"孙楼街道","320321102":"首羡镇","320321103":"顺河镇","320321104":"常店镇","320321105":"欢口镇","320321106":"师寨镇","320321107":"华山镇","320321108":"梁寨镇","320321109":"范楼镇","320321111":"宋楼镇","320321112":"大沙河镇","320321113":"王沟镇","320321114":"赵庄镇","320321401":"大沙河林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320321.json
// module id = 789
// module chunks = 0